import { type Row } from 'write-excel-file/browser';

const textRow = (value: string): Row => [{ value, type: String }];

export default textRow;
